import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetLengthOfStayKpiRequestDtoSchema = z.object({
  facilityId: z.number().optional(),
});

const GetLengthOfStayKpiResponseDtoSchema = z.object({
  medianDays: z.number().nullable(),
});

export type GetLengthOfStayKpiRequestDto = z.infer<
  typeof GetLengthOfStayKpiRequestDtoSchema
>;
export type GetLengthOfStayKpiResponseDto = z.infer<
  typeof GetLengthOfStayKpiResponseDtoSchema
>;

export const getLengthOfStayKpi = (
  params: GetLengthOfStayKpiRequestDto,
  config?: AxiosRequestConfig<GetLengthOfStayKpiRequestDto>
) => {
  const validatedParams = GetLengthOfStayKpiRequestDtoSchema.parse(params);
  return api
    .get('/residents/length-of-stay', {
      params: validatedParams,
      ...config,
    })
    .then(responseContract(GetLengthOfStayKpiResponseDtoSchema));
};
